import IconBase from "react-icon-base";

export default function Icon(props) {
  return (
    <IconBase
      {...props}
      viewBox={"0 0 24 24"}
      dangerouslySetInnerHTML={{
        __html: `<svg width="100%" height="100%" viewBox="0 0 122 85" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/">
        <path d="M118.9,13.3C117.5,8.1 113.4,4 108.2,2.6C98.7,0 60.7,0 60.7,0C60.7,0 22.7,0 13.2,2.5C8.1,3.9 3.9,8.1 2.5,13.3C0,22.8 0,42.5 0,42.5C0,42.5 0,62.3 2.5,71.7C3.9,76.9 8,81 13.2,82.4C22.8,85 60.7,85 60.7,85C60.7,85 98.7,85 108.2,82.5C113.4,81.1 117.5,77 118.9,71.8C121.4,62.3 121.4,42.6 121.4,42.6C121.4,42.6 121.5,22.8 118.9,13.3ZM80.2,42.5L48.6,60.7L48.6,24.3L80.2,42.5Z"/>
    </svg>    
`,
      }}
    />
  );
}
